import GameLoaderComponent from '@nackle/game-loader-component';
import React from 'react';
import { Component } from 'react';

type GameLoaderProps = GameLoaderComponent extends Component<infer P> ? P : never

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function GameLoaderBridge(props: GameLoaderProps | {any}) {
    if (!('romId' in props)) {
        return <></>;
    }

    return <GameLoaderComponent {...props} />;
}
